import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel160W() {
    const { useLang } = useGlobal();
    const { t } = useLang('product');
    const languageT = (value: string) => t(`solarpanels.${value}`);
    const webpUrl = '/media/solarpanel_160w/pc/';
    const bannerData = [
        {
            bgImgs: ['1_banner_160w.webp', '1_banner_160w.jpg'],
            logo_url: '/img/logo.png',
            title: languageT('160w_title'),
            des: languageT('solar_panels'),
        },
    ];
    const bannerConfig = {
        theme: 'black',
        isShowLogo: false,
        webpUrl,
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-65px' }}>
                <BannerModule data={bannerData} config={bannerConfig} />
            </div>
            <Content />
        </div>
    );
}
